<div class="container-fluid tp-box" *ngIf="config && config.arhold" [@flipState]="flip" @grow>
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="card">
			<div class="card-header card-header-danger card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false)">
					<i class="material-icons">lock</i>
				</div>
				<h3 class="card-title">On Hold Customers</h3>
			</div>
			<div class="card-body" *ngIf="viewing && viewing.length">
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th>Customer</th>
								<th>Reason</th>
								<th class="text-right">Balance</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let c of viewing">
								<td>{{ c.name || c.debtorno }}</td>
								<td>{{ c.reasondescription || 'On hold' }}</td>
								<td class="text-right">{{ c.balance | currency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="card-body" *ngIf="viewing && !viewing.length">
				<p class="text-muted mb-0">No customers on hold.</p>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-danger card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(true)">
					<i class="material-icons">lock</i>
				</div>
				<p class="card-category">On Hold Customers</p>
				<h3 class="card-title">
					<span *ngIf="!isLoading">{{ items.length }}</span>
					<span *ngIf="isLoading">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats" [class.pointer]="!isLoading">
					<a *ngIf="!isLoading" (click)="toggleFlip(true)">
						<i class="material-icons">list</i>
						View list
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
